import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import {
  NoMarkErrorComponent,
  SuccessComponent,
} from '../ValidatedInput/DefaultTooltipComponents';

import styles from './ValidatedPinInput.module.scss';
import ValidatedInput from '../ValidatedInput/ValidatedInput';

const ValidatedPinInput = ({
  onChange,
  pinLength,
  clearErrors,
  clearOtherErrors,
  autoFocus,
  handleSubmit,
  ...rest
}) => {
  const [visible, setVisible] = useState(false);
  const [pinValues, setPinValues] = useState(new Array(pinLength).fill(''));

  const handleChange = (e, index) => {
    const newValue = e.target.value;
    if (/^[0-9]*$/.test(newValue)) {
      const newPinValues = [...pinValues];

      // Solo setear el valor si estás en el primer input o el anterior no está vacío
      if (index === 0 || newPinValues[index - 1] !== '') {
        newPinValues[index] = newValue;
        setPinValues(newPinValues);
      }

      // Reenfocar al primer input vacío desde el principio si se escribe fuera de orden
      const firstEmptyIndex = newPinValues.findIndex(value => value === '');
      if (firstEmptyIndex !== -1) {
        document.getElementById(`pin-input-${firstEmptyIndex}`).focus();
      } else if (newValue && index < pinLength - 1) {
        document.getElementById(`pin-input-${index + 1}`).focus();
      }

      // Ejecutar funciones de callback
      if (onChange) onChange(newPinValues.join(''));
      if (clearErrors) clearErrors();
      if (clearOtherErrors) clearOtherErrors();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' || e.key === 'Delete') {
      setPinValues(prevPinValues => {
        const newPinValues = [...prevPinValues];
        for (let i = index; i < pinLength; i++) {
          newPinValues[i] = '';
        }
        if (onChange) onChange(newPinValues.join(''));

        return newPinValues;
      });

      if (e.key === 'Backspace' && !pinValues[index] && index > 0) {
        document.getElementById(`pin-input-${index - 1}`).focus();
      }
    }

    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const singleInputs = useMemo(
    () =>
      new Array(pinLength)
        .fill()
        .map((_, i) => (
          <input
            type={visible ? 'text' : 'password'}
            maxLength="1"
            autoComplete="new-password"
            onChange={e => handleChange(e, i)}
            onKeyDown={e => handleKeyDown(e, i)}
            key={i}
            id={`pin-input-${i}`}
            value={pinValues[i]}
            autoFocus={autoFocus && i === 0}
          />
        )),
    [pinLength, visible, pinValues],
  );
  const handleShowHide = () => setVisible(nowVisible => !nowVisible);
  return (
    <ValidatedInput
      ErrorComponent={NoMarkErrorComponent}
      SuccessComponent={SuccessComponent({})}
      {...rest}
    >
      <div className={styles.pinContainer}>
        {singleInputs}
        <button
          type="button"
          style={{
            position: 'relative',
          }}
          onClick={handleShowHide}
        >
          {visible ? (
            <AiFillEye style={{ position: 'absolute' }} />
          ) : (
            <AiFillEyeInvisible style={{ position: 'absolute' }} />
          )}
        </button>
      </div>
    </ValidatedInput>
  );
};

ValidatedPinInput.propTypes = {
  onChange: PropTypes.func,
  pinLength: PropTypes.number,
};

ValidatedPinInput.defaultProps = {
  pinLength: 6,
};

export default ValidatedPinInput;
